import HomeTermsAndConditions from './HomeTermsAndConditions';

export default HomeTermsAndConditions;
